var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box as MuiBox, Menu as MuiMenu } from '@mui/material';
import Avatar from '../../Avatar';
import Divider from '../../Divider';
import ListItem from '../../NavBar/AccountMenu/ListItem';
import UserDetail from '../../NavBar/AccountMenu/UserDetail';
import { useState } from 'react';
import colors from '../../../themes/colors';
import { shadows } from '../../../themes/legacy/theme';
var muiMenuListProps = {
    sx: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    }
};
var muiMenuPaperProps = {
    elevation: 0,
    sx: {
        padding: '8px',
        borderRadius: '8px',
        overflow: 'visible',
        width: 260,
        mt: 0.75,
        ml: 1.75,
        '&:after': {
            content: '""',
            position: 'absolute',
            left: -7,
            bottom: 12,
            width: 11,
            height: 11,
            backgroundColor: colors.white,
            transform: 'translateY(-50%) rotate(-45deg)',
            borderLeft: "2px solid ".concat(colors.legacy.mistDarker),
            borderTop: "2px solid ".concat(colors.legacy.mistDarker),
            zIndex: 1
        },
        boxShadow: shadows.light3
    }
};
export default function AccountMenu(_a) {
    var accountMenuItems = _a.accountMenuItems, user = _a.user, pathname = _a.pathname;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleOpen = function (event) {
        if (event.currentTarget)
            setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    return (_jsxs(_Fragment, { children: [_jsx(MuiBox, __assign({ onClick: handleOpen, "aria-controls": open ? 'account-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, sx: { margin: '0 auto', padding: 0, cursor: 'pointer' } }, { children: _jsx(Avatar, { firstName: user.firstName, lastName: user.lastName, variant: "small" }) })), _jsxs(MuiMenu, __assign({ id: "account-menu", anchorEl: anchorEl, open: open, onClose: handleClose, onClick: handleClose, PaperProps: muiMenuPaperProps, MenuListProps: muiMenuListProps, transformOrigin: { horizontal: 'left', vertical: 'bottom' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: [_jsx(UserDetail, { user: user }), _jsx(Divider, { margin: 4 }), accountMenuItems.map(function (menuItem) { return (_jsxs("div", { children: [_jsx(ListItem, { item: menuItem, isActive: menuItem.pathname === pathname }), menuItem.trailingDivider && _jsx(Divider, { margin: 8 })] }, menuItem.label)); })] }))] }));
}
